/* istanbul ignore file */
import { TypographyClassKey } from '@material-ui/core/Typography';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDTypographyStyles: Partial<
  Record<TypographyClassKey, CSSProperties>
> = {
  root: {
    htmlFontSize: 16,
    fontSize: 1.4,
    fontWeight: 400,
    fontFamily: 'Helvetica Neue LT Pro',
  },
  h1: {
    fontsize: '6rem',
    fontWeight: 400,
  },
  h2: {
    fontsize: '3.75rem',
    fontWeight: 400,
  },
  h3: {
    fontsize: '3rem',
    fontWeight: 400,
  },
  h4: {
    fontSize: '2.125rem',
    fontWeight: 400,
  },
  h5: {
    fontSize: '1.5rem',
    fontWeight: 400,
  },
  h6: {
    fontSize: '1.25rem',
    fontWeight: 400,
  },
  body1: {
    fontSize: '1.3rem',
    letterSpacing: '0.01071em',
  },
  body2: {
    fontSize: '1rem',
  },
  subtitle1: {
    fontSize: '1.5rem',
  },
  paragraph: {
    fontsize: '1.4rem',
  },
  colorError: {
    color: 'rgb(216, 17, 24)',
  },
};
